// extracted by mini-css-extract-plugin
export default {"endGameContainer":"styles_endGameContainer__lv4sp","winner":"styles_winner__iHCXK"};